module.exports = __webpack_public_path__ + "static/img/yinxiang1.9ca3678.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newSpark/yinxiang1.png
// module id = Rh1z
// module chunks = 12